import React from "react";
import useAssetChargesSummary from "src/hooks/useAssetChargesSummary";
import AssetChargesSummaryModal from "src/components/billing/AssetChargesSummaryModal";

const AssetChargesSummaryModalWrapper = () => {
  const assetChargesSummary = useAssetChargesSummary();

  if (!assetChargesSummary.showChargesSummary) return null;

  return (
    <AssetChargesSummaryModal
      assetId={assetChargesSummary.assetId}
      assetReplayLogId={assetChargesSummary.assetReplayLogId}
      startDate={assetChargesSummary.startDate}
      endDate={assetChargesSummary.endDate}
      editingCharges={assetChargesSummary.editingCharges}
      detailsExpanded={assetChargesSummary.detailsExpanded}
      onEditCharges={assetChargesSummary.handleEditCharges}
      onStopEditing={assetChargesSummary.handleStopEditing}
      onToggleDetails={assetChargesSummary.handleToggleDetails}
      onUpdateReplayLogId={assetChargesSummary.handleUpdateReplayLogId}
      onClose={assetChargesSummary.handleClose}
    />
  );
};

export default AssetChargesSummaryModalWrapper;
